module.exports = __webpack_public_path__ + "img/qcode_loading.ae796bc3.jpg";